@use "../../styles.scss" as *;

.Card {
  border-radius: 6px;
  background: white;
  box-shadow: $variables-shadow-1;

  &.WithScrollBar {
    ::-webkit-scrollbar {
      width: 1rem;
      height: 2rem;
    }

    /* Track */
    // ::-webkit-scrollbar-track {
    //   background: $color-grey;
    // }

    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: $colors-color-green;
    }
  }
}
